import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/lib/firebase";

export const subscribeNewsletter = async (email, source) => {
  const cleanEmail = email.trim().toLowerCase();
  await addDoc(collection(db, "newsletter_subscribers"), {
    email: cleanEmail,
    source,
    status: "subscribed",
    createdAt: serverTimestamp(),
  });
};
